<template>
    <div class="sidebar">
        <el-menu active-text-color="#fff" text-color="#fff" background-color="transparent" class="sidebar-menu"
                 :default-active="$route.path.split('/').length>2?('/'+$route.path.split('/')[1]):$route.path"
                 :default-openeds="SideOpen"
                 :collapse="isCollapse"
                 unique-opened router>

            <el-menu-item index="/account" class="accountMenuItem">
                <div class="sidebar-user">
                    <div class="sidebar-avatar">
                        <img v-if="getCompanyLogoUrlByCompany(selectedCompany) !== '' && !isCompanyLogoFailed(selectedCompany)"
                             class="sidebar-avatar-image"
                             :class="{'is-visible': isCompanyLogoLoaded(selectedCompany)}"
                             :src="getCompanyLogoUrlByCompany(selectedCompany)"
                             alt=""
                             @load="markCompanyLogoLoaded(selectedCompany)"
                             @error="markCompanyLogoFailed(selectedCompany)">
                        <span v-if="getCompanyLogoUrlByCompany(selectedCompany) === '' || isCompanyLogoFailed(selectedCompany) || !isCompanyLogoLoaded(selectedCompany)">
                            {{getCompanyInitial(selectedCompany)}}
                        </span>
                    </div>
                    <div class="sidebar-user-content">
                        <div class="sidebar-user-name">{{selectedCompany ? selectedCompany.companyName : ''}}</div>
                        <div class="sidebar-user-email">{{loginEmail}}</div>
                    </div>
                    <div class="companyDropdownWrapper" @click.stop>
                        <el-dropdown trigger="click"
                                     class="companyDropdown"
                                     popper-class="company-dropdown-popper"
                                     @visible-change="handleCompanyDropdownVisible"
                                     @command="handleCompanyCommand">
                            <button type="button" class="companyArrowButton">
                                <i class="el-icon-arrow-down companyArrow"></i>
                            </button>
                            <el-dropdown-menu slot="dropdown" class="companyDropdownMenu">
                                <el-dropdown-item
                                        v-for="company in companyList"
                                        :key="company.innerUUID"
                                        :command="company.innerUUID"
                                        class="companyDropdownItem">
                                    <div class="companyOption">
                                        <div v-if="getCompanyLogoUrlByCompany(company) !== '' && !isCompanyLogoFailed(company)"
                                             class="companyOptionLogo"
                                             :class="{'is-visible': isCompanyLogoLoaded(company)}">
                                            <img class="companyOptionLogoImage"
                                                 :src="getCompanyLogoUrlByCompany(company)"
                                                 alt=""
                                                 style="width: 50px; height: 50px; object-fit: cover;"
                                                 @load="markCompanyLogoLoaded(company)"
                                                 @error="markCompanyLogoFailed(company)">
                                        </div>
                                        <span class="companyOptionName">{{company.companyName}}</span>
                                    </div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </el-menu-item>

            <el-menu-item index="/invoice">
                <i class="el-icon-s-home sidebar-menu-icon"></i>
                <span class="menuValue">Invoices</span>
            </el-menu-item>

            <el-menu-item index="/estimate">
                <i class="el-icon-date sidebar-menu-icon"></i>
                <span class="menuValue">Estimates</span>
            </el-menu-item>

            <el-menu-item v-if="showPurchaseOrderMenu" index="/purchaseOrder">
                <i class="el-icon-document-copy sidebar-menu-icon"></i>
                <span class="menuValue">Purchase Order</span>
            </el-menu-item>

            <el-menu-item index="/item">
                <i class="el-icon-shopping-bag-2 sidebar-menu-icon"></i>
                <span class="menuValue">Items</span>
            </el-menu-item>
            <el-menu-item index="/client">
                <i class="el-icon-user sidebar-menu-icon"></i>
                <span class="menuValue">Clients</span>
            </el-menu-item>

            <el-menu-item index="/expense">
                <i class="el-icon-coin sidebar-menu-icon"></i>
                <span class="menuValue">Expenses</span>
            </el-menu-item>

            <el-menu-item v-if="showReportMenu" index="/report">
                <i class="el-icon-data-analysis sidebar-menu-icon"></i>
                <span class="menuValue">Reports</span>
            </el-menu-item>


            <el-submenu index="/setting">
                <template slot="title">
                    <i class="el-icon-setting sidebar-menu-icon"></i>
                    <span class="menuValue">Settings</span>
                </template>
                <el-menu-item-group class="subMenuValue">
                    <el-menu-item index="/company_info" class="sidebar-submenu-child">
                        <i class="el-icon-office-building sidebar-submenu-icon"></i>
                        <span>Company info</span>
                    </el-menu-item>
                    <el-menu-item index="/setting" class="sidebar-submenu-child">
                        <i class="el-icon-document sidebar-submenu-icon"></i>
                        <span>Taxes</span>
                    </el-menu-item>
                    <el-menu-item index="/default" class="sidebar-submenu-child">
                        <i class="el-icon-s-operation sidebar-submenu-icon"></i>
                        <span>Default</span>
                    </el-menu-item>
                    <el-menu-item index="/invoice-design" class="sidebar-submenu-child">
                        <i class="el-icon-edit-outline sidebar-submenu-icon"></i>
                        <span>Customize invoice</span>
                    </el-menu-item>
                </el-menu-item-group>
            </el-submenu>

            <el-menu-item index="/feedback">
                <i class="el-icon-message sidebar-menu-icon"></i>
                <span class="menuValue">Send Feedback</span>
            </el-menu-item>


        </el-menu>
        <button type="button" class="signOutButton" @click="loginOutDialog = true">
            <i class="el-icon-right"></i>
            <span>Sign out</span>
        </button>
        <el-dialog
                title="Sign out"
                :visible.sync="loginOutDialog"
                width="30%">
            <span>Are you sure sign out?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="loginOutDialog = false">Cancel</el-button>
                <el-button type="primary" :disabled="buttonDisabledStatus" :loading="loading" @click="loginOut()">Sign out</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        applyCompanySelectionByIndex,
        getSelectedCompanyIndex,
        getStoredCompanyList,
        syncCompanySelection
    } from '@/utils/company'
    import {getDownloadV2Url} from '@/utils/fileUpload'

    export default {
        name: "leftMenu",
        data() {
            return {
                SideOpen: ["setting"],
                loginOutDialog: false,
                isCollapse: false,
                pt: '',
                loginEmail: "",
                buttonDisabledStatus: false,
                loading: false,
                companyList: [],
                selectedCompany: null,
                companyLogoMap: {},
                companyLogoMapLoaded: false,
                failedLogoCompanyUUIDMap: {},
                loadedLogoCompanyUUIDMap: {},
                switchCompanyLoading: false,
                showPurchaseOrderMenu: false,
                showReportMenu: true
            }
        },
        methods: {
            loginOut() {
                let that = this;
                this.loading = true;
                this.buttonDisabledStatus = true;
                this.$axios.post('login_out', {
                    params: {}
                }).then(() => {
                    localStorage.clear();
                    that.$router.push('/login');
                    this.buttonDisabledStatus = false;
                    this.loading = false;
                }).catch(function () {
                    that.buttonDisabledStatus = false;
                    that.loading = false;
                })
            },
            loadCompanyListFromStorage() {
                this.companyList = getStoredCompanyList();
                const selectedCompanyIndex = getSelectedCompanyIndex();
                if (selectedCompanyIndex >= 0 && selectedCompanyIndex < this.companyList.length) {
                    this.selectedCompany = this.companyList[selectedCompanyIndex];
                    return;
                }
                this.selectedCompany = null;
            },
            loadCompanyListIfNeeded() {
                this.loadCompanyListFromStorage();
                if (this.companyList.length > 0 && this.companyLogoMapLoaded) {
                    return;
                }
                this.switchCompanyLoading = true;
                let that = this;
                this.$axios.post('query_setting_and_company', {
                    params: {}
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        let selectedData = syncCompanySelection(response.data);
                        that.companyLogoMap = response.data.companyLogoMap;
                        that.companyLogoMapLoaded = true;
                        that.failedLogoCompanyUUIDMap = {};
                        that.loadedLogoCompanyUUIDMap = {};
                        that.companyList = getStoredCompanyList();
                        if (selectedData != null) {
                            that.selectedCompany = that.companyList[selectedData.index];
                        }
                    }
                    that.switchCompanyLoading = false;
                }).catch(function () {
                    that.switchCompanyLoading = false;
                })
            },
            handleCompanyDropdownVisible(visible) {
                if (visible) {
                    this.loadCompanyListIfNeeded();
                }
            },
            handleCompanyCommand(companyUUID) {
                const index = this.companyList.findIndex(item => item.innerUUID === companyUUID);
                if (index === -1 || index === getSelectedCompanyIndex()) {
                    return;
                }
                let currentSelection = applyCompanySelectionByIndex(index);
                if (currentSelection == null) {
                    return;
                }
                window.location.reload();
            },
            getCompanyLogoUrl(companyLogo) {
                if (companyLogo.remoteKey != null && companyLogo.remoteKey !== "") {
                    return getDownloadV2Url(this.$store.state.requestURL, companyLogo.remoteKey);
                }
                return this.$store.state.requestURL + "file/download?fileName=" + companyLogo.imagePath + "&email=" + JSON.parse(localStorage.getItem("loginInformation")).objectData.email;
            },
            getCompanyLogoUrlByCompany(company) {
                if (company == null) {
                    return "";
                }
                let companyLogo = this.companyLogoMap[company.innerUUID];
                if (companyLogo == null) {
                    return "";
                }
                if (companyLogo.syncStatus === 1) {
                    return "";
                }
                if ((companyLogo.remoteKey == null || companyLogo.remoteKey === "") && (companyLogo.imagePath == null || companyLogo.imagePath === "")) {
                    return "";
                }
                return this.getCompanyLogoUrl(companyLogo);
            },
            markCompanyLogoFailed(company) {
                if (company == null) {
                    return;
                }
                this.$set(this.failedLogoCompanyUUIDMap, company.innerUUID, true);
            },
            markCompanyLogoLoaded(company) {
                if (company == null) {
                    return;
                }
                this.$set(this.loadedLogoCompanyUUIDMap, company.innerUUID, true);
            },
            isCompanyLogoFailed(company) {
                if (company == null) {
                    return false;
                }
                return this.failedLogoCompanyUUIDMap[company.innerUUID] === true;
            },
            isCompanyLogoLoaded(company) {
                if (company == null) {
                    return false;
                }
                return this.loadedLogoCompanyUUIDMap[company.innerUUID] === true;
            },
            getCompanyInitial(company) {
                if (company == null || company.companyName == null || company.companyName === "") {
                    return "";
                }
                return company.companyName.substring(0, 1).toUpperCase();
            }
        }, mounted() {
            let loginInformation = JSON.parse(localStorage.getItem("loginInformation"));
            if (null != loginInformation) {

                this.loginEmail = loginInformation.objectData.email;
            }

            this.loadCompanyListFromStorage();
            this.loadCompanyListIfNeeded();
        }
    }
</script>

<style scoped>
    .sidebar {
        display: flex;
        flex-direction: column;
        flex: 0 0 300px;
        width: 300px;
        min-width: 300px;
        box-sizing: border-box;
        padding: 24px 18px 18px;
        color: rgba(255, 255, 255, 0.78);
        background: linear-gradient(180deg, #13264d 0%, #101d3a 100%);
        border-radius: 0 20px 20px 0;
        box-shadow: 8px 0 32px rgba(17, 37, 76, 0.14);
        height: 100vh;
        overflow-y: auto;
        font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
    }

    .sidebar-menu {
        flex: 1;
        width: 100%;
        padding: 0;
        border: none;
        background: transparent !important;
    }

    .menuValue {
        flex: 1;
        margin-left: 0;
        font-size: 15px;
        font-weight: 600;
    }

    .sidebar-menu-icon {
        width: 22px;
        flex: 0 0 22px;
        margin-right: 14px;
        color: rgba(255, 255, 255, 0.68);
        font-size: 22px;
        text-align: center;
    }

    .accountMenuItem {
        height: auto !important;
        line-height: normal !important;
        padding: 0 !important;
        margin: 0 0 16px !important;
        background: transparent !important;
    }

    .accountMenuItem:hover,
    .accountMenuItem:focus,
    .accountMenuItem.is-active {
        background-color: transparent !important;
    }

    .sidebar-user {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 14px 6px 24px;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        cursor: pointer;
    }

    .sidebar-avatar {
        width: 48px;
        height: 48px;
        flex: 0 0 48px;
        display: grid;
        place-items: center;
        overflow: hidden;
        border-radius: 12px;
        color: #ffffff;
        background: linear-gradient(135deg, #6b7cff, #4b45e8);
        font-size: 24px;
        font-weight: 700;
        line-height: 1;
        box-shadow: 0 12px 28px rgba(75, 69, 232, 0.28);
    }

    .sidebar-avatar-image {
        width: 100%;
        height: 100%;
        display: none;
        object-fit: contain;
        background: #ffffff;
    }

    .sidebar-avatar-image.is-visible {
        display: block;
    }

    .sidebar-user-content {
        flex: 1;
        min-width: 0;
    }

    .sidebar-user-name {
        overflow: hidden;
        color: #ffffff;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .sidebar-user-email {
        margin-top: 2px;
        overflow: hidden;
        color: rgba(255, 255, 255, 0.68);
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .companyDropdownWrapper {
        flex: 0 0 auto;
    }

    .companyDropdown {
        display: block;
    }

    .companyArrowButton {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        background: transparent;
        color: #ffffff;
        cursor: pointer;
        padding: 0;
    }

    .companyArrow {
        color: rgba(255, 255, 255, 0.72);
        font-size: 16px;
    }

    .sidebar-menu >>> .el-menu-item:not(.accountMenuItem),
    .sidebar-menu >>> .el-submenu__title {
        height: 50px !important;
        line-height: 50px !important;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin: 0 0 6px;
        padding: 0 14px !important;
        border-radius: 11px;
        color: rgba(255, 255, 255, 0.78) !important;
        background: transparent !important;
        font-size: 15px;
        font-weight: 600;
        transition: color 180ms ease, background 180ms ease, box-shadow 180ms ease, transform 180ms ease;
    }

    .sidebar-menu >>> .el-menu-item:not(.accountMenuItem):hover,
    .sidebar-menu >>> .el-submenu__title:hover {
        color: #ffffff !important;
        background: rgba(255, 255, 255, 0.07) !important;
    }

    .sidebar-menu >>> .el-menu-item.is-active:not(.accountMenuItem):not(.sidebar-submenu-child) {
        color: #ffffff !important;
        background: linear-gradient(90deg, #2676f3 0%, #315edb 100%) !important;
        box-shadow: 0 8px 22px rgba(36, 105, 230, 0.28);
    }

    .sidebar-menu >>> .el-menu-item.is-active:not(.accountMenuItem):not(.sidebar-submenu-child) .sidebar-menu-icon,
    .sidebar-menu >>> .el-menu-item:not(.accountMenuItem):hover .sidebar-menu-icon,
    .sidebar-menu >>> .el-submenu__title:hover .sidebar-menu-icon,
    .sidebar-menu >>> .el-submenu.is-opened > .el-submenu__title .sidebar-menu-icon {
        color: #ffffff;
    }

    .sidebar-menu >>> .el-submenu.is-opened > .el-submenu__title {
        color: #ffffff !important;
    }

    .sidebar-menu >>> .el-submenu__icon-arrow {
        right: 14px;
        color: rgba(255, 255, 255, 0.72);
        font-weight: 700;
    }

    .subMenuValue {
        margin: 4px 0 8px 38px;
        padding-left: 18px;
        border-left: 1px solid rgba(255, 255, 255, 0.1);
        font-size: 14px;
    }

    .subMenuValue >>> .el-menu-item-group__title {
        display: none;
        padding: 0;
    }

    .subMenuValue >>> .el-menu-item.sidebar-submenu-child {
        min-height: 42px !important;
        height: 42px !important;
        line-height: 42px !important;
        display: flex;
        align-items: center;
        margin: 3px 0;
        padding: 0 12px !important;
        border-radius: 9px;
        color: rgba(255, 255, 255, 0.66) !important;
        background: transparent !important;
        box-shadow: none;
        font-size: 14px;
        font-weight: 500;
    }

    .subMenuValue >>> .el-menu-item.sidebar-submenu-child:hover {
        color: #ffffff !important;
        background: rgba(255, 255, 255, 0.06) !important;
    }

    .subMenuValue >>> .el-menu-item.sidebar-submenu-child.is-active {
        color: #9fc4ff !important;
        background: rgba(54, 119, 246, 0.16) !important;
        box-shadow: none;
    }

    .sidebar-submenu-icon {
        width: 18px;
        flex: 0 0 18px;
        margin-right: 10px;
        color: currentColor;
        font-size: 18px;
        text-align: center;
    }

    .signOutButton {
        width: 100%;
        height: 64px;
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        gap: 14px;
        box-sizing: border-box;
        margin-top: 20px;
        padding: 0 24px;
        border: 0;
        border-radius: 11px;
        color: #ffffff;
        background: rgba(54, 98, 190, 0.38);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
        cursor: pointer;
        font-size: 15px;
        font-weight: 700;
        text-align: left;
        transition: background 180ms ease, transform 180ms ease, box-shadow 180ms ease;
    }

    .signOutButton:hover {
        background: rgba(54, 119, 246, 0.46);
        box-shadow: 0 10px 24px rgba(12, 30, 67, 0.16);
    }

    .signOutButton:active {
        transform: scale(0.985);
    }

    .signOutButton i {
        font-size: 24px;
    }
</style>

<style>
    .company-dropdown-popper,
    .companyDropdownMenu {
        min-width: 280px !important;
        max-width: 320px !important;
        padding: 10px 0;
    }

    .company-dropdown-popper .companyDropdownItem {
        height: auto;
        padding: 12px 16px;
        line-height: normal;
        box-sizing: border-box;
    }

    .company-dropdown-popper .companyOption {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 14px;
        width: 250px;
        max-width: 250px;
        min-height: 58px;
        overflow: hidden;
    }

    .company-dropdown-popper .companyOptionLogo {
        width: 50px !important;
        height: 50px !important;
        min-width: 50px !important;
        max-width: 50px !important;
        min-height: 50px !important;
        max-height: 50px !important;
        flex: 0 0 50px !important;
        display: none;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border-radius: 12px;
        background: #ffffff;
    }

    .company-dropdown-popper .companyOptionLogo.is-visible {
        display: flex;
    }

    .company-dropdown-popper .companyOptionLogo img,
    .company-dropdown-popper .companyOptionLogoImage {
        width: 50px !important;
        height: 50px !important;
        min-width: 50px !important;
        max-width: 50px !important;
        min-height: 50px !important;
        max-height: 50px !important;
        object-fit: cover !important;
        display: block;
        background: #ffffff;
    }

    .company-dropdown-popper .companyOptionName {
        flex: 1;
        max-width: 230px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 16px;
        color: #303133;
    }
</style>
